import { Editor } from "@tinymce/tinymce-react";
import { useEffect, useState } from "react";

const isDarkMode = () =>
  document.documentElement.classList.contains("dark");

const TinyEditor = ({ value, onChange }) => {
  const [isDark, setIsDark] = useState(isDarkMode());
  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(isDarkMode());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Editor
      key={isDark ? "dark-editor" : "light-editor"} 
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      value={value}
      onEditorChange={onChange}
      init={{
        height: 300,
        menubar: false,
        skin: isDark ? "oxide-dark" : "oxide",
        content_css: isDark ? "dark" : "default",

        plugins: [
          "advlist",
          "autolink",
          "lists",
          "link",
          "image",
          "media",
          "table",
          "code",
          "preview",
          "fullscreen",
          "searchreplace",
          "wordcount",
          "help",
        ],
        toolbar:
          "undo redo | blocks fontfamily fontsize | " +
          "bold italic underline strikethrough | forecolor backcolor | " +
          "alignleft aligncenter alignright alignjustify | " +
          "bullist numlist outdent indent | " +
          "link image media table | " +
          "code preview fullscreen",

        image_title: true,
        automatic_uploads: true,
        file_picker_types: "image",
        image_advtab: true,
        file_picker_callback: (callback) => {
          const url = prompt("Enter image URL");
          if (url) callback(url, { alt: "Image" });
        },


        content_style: `
          body {
            font-family: Poppins, Inter, Arial;
            font-size: 14px;
            background-color: ${isDark ? "#020617" : "#ffffff"};
            color: ${isDark ? "#e5e7eb" : "#0f172a"};
          }
        `,
      }}
    />
  );
};

export default TinyEditor;